import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async'; // ✅ Ajouté
import HelpChatPage from './pages/HelpChatPage'; // Import de la page d'aide
import AdminPage from './pages/AdminPage';
import GestionInfos from './pages/GestionInfos';
import DashboardVeille from './pages/DashboardVeille';
import GestionePulizie from './pages/GestionePulizie';
import GestionePrenotazioni from './pages/GestionePrenotazioni';
import GuidePage from './pages/GuidePage';
import HelpVideosPage from './pages/HelpVideosPage';
import CodeKeyboxPage from './pages/CodeKeyboxPage';
import HelpChatLanguageSelector from './components/HelpChatLanguageSelector'; // Import du sélecteur de langue
import App from './App';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HelmetProvider> {/* ✅ Fournisseur Helmet */}
      <BrowserRouter>
      <Suspense fallback={<div>Loading translations…</div>}>
        <Routes>
          <Route path="/" element={<Navigate to="/it/affitto-villa-appartamento-sardegna-san-teodoro" />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/gestion-infos" element={<GestionInfos />} />
          <Route path="/admin/dashboard-veille" element={<DashboardVeille />} />
          <Route path="/admin/gestione-pulizie" element={<GestionePulizie />} />
          <Route path="/admin/gestione-prenotazioni" element={<GestionePrenotazioni />} />
          <Route path="/code" element={<Navigate to="/code/en" replace />} />
          <Route path="/code/:lang" element={<CodeKeyboxPage />} />
          <Route path="/guide/:routeSlug" element={<GuidePage />} />
          <Route path="/guides/:routeSlug" element={<GuidePage />} />

          <Route path="/fr/location-maison-appartement-sardaigne-san-teodoro/*" element={<App lang="fr" />} />
          <Route path="/it/affitto-villa-appartamento-sardegna-san-teodoro/*" element={<App lang="it" />} />
          <Route path="/en/sardinia-villa-apartment-rental-san-teodoro/*" element={<App lang="en" />} />
          <Route path="/de/ferienhaus-sardinien-san-teodoro/*" element={<App lang="de" />} />
          <Route path="/pt/aluguel-villa-sardenha-san-teodoro/*" element={<App lang="pt" />} />
          <Route path="/es/alquiler-villa-sardinia-san-teodoro/*" element={<App lang="es" />} />
          <Route path="/ru/arenda-villy-sardinija-san-teodoro/*" element={<App lang="ru" />} />

          <Route path="/help" element={<HelpChatLanguageSelector />} />
          {/* Route statique : prioritaire sur /help/:lang (chat) */}
          <Route path="/help/videos" element={<HelpVideosPage />} />
          <Route path="/help/:lang" element={<HelpChatPage />} />
        </Routes>
      </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
